/**
 * As contas da caixa de entrada que não dependem do banco.
 *
 * Duas coisas estavam erradas no adaptador do servidor: a etiqueta "Lead" era
 * dada a quem NÃO tinha contato — e lead tem contato, então a aba Leads só
 * mostrava número desconhecido —, e os canais diziam zero conversa aberta e
 * zero não lida, fixo.
 */

/** Etapas em que o lead já não é oportunidade em aberto. */
const LEAD_FECHADO = new Set(['ganho', 'perdido']);

export interface VinculosDoContato {
    /** Contatos que têm ficha de paciente. */
    pacientes: Set<string>;
    /** Contatos com lead em aberto. */
    leadsAbertos: Set<string>;
}

export function contatosComLeadAberto(leads: { contato_id?: unknown; etapa?: unknown }[]): Set<string> {
    return new Set(leads
        .filter((l) => l.contato_id && !LEAD_FECHADO.has(String(l.etapa ?? '')))
        .map((l) => String(l.contato_id)));
}

/**
 * O vínculo da pessoa, deduzido do cadastro: ficha de paciente é "Paciente",
 * lead em aberto é "Lead" (a mesma pessoa pode ser as duas). Número que nem
 * virou contato ainda é prospecção, e fica como "Lead" — como já ficava.
 *
 * Chamava-se `etiquetasDaConversa` até 22/09/2026, quando etiqueta passou a ser
 * uma coisa que a clínica cria e gruda (0168). Dedução e marcação dividindo o
 * mesmo nome fariam a tela oferecer para tirar o que não se tira.
 */
export function vinculosDaConversa(contatoId: string | null, vinculos: VinculosDoContato): string[] {
    if (!contatoId) return ['Lead'];
    const achados: string[] = [];
    if (vinculos.pacientes.has(contatoId)) achados.push('Paciente');
    if (vinculos.leadsAbertos.has(contatoId)) achados.push('Lead');
    return achados;
}

export function contagemPorCanal(conversas: { canal_id?: unknown; estado?: unknown; nao_lidas?: unknown }[]): Map<string, { abertas: number; naoLidas: number }> {
    const porCanal = new Map<string, { abertas: number; naoLidas: number }>();
    for (const c of conversas) {
        if (!c.canal_id) continue;
        const id = String(c.canal_id);
        const atual = porCanal.get(id) ?? { abertas: 0, naoLidas: 0 };
        if (c.estado !== 'resolvida') atual.abertas += 1;
        atual.naoLidas += Number(c.nao_lidas ?? 0);
        porCanal.set(id, atual);
    }
    return porCanal;
}
